import * as React from 'react';

function SvgDelete(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="1em" viewBox="0 0 15 20" width="1em" {...props}>
      <path
        d="M1.071 17.778C1.071 19 2.036 20 3.214 20h8.572c1.178 0 2.143-1 2.143-2.222V4.444H1.07v13.334zM15 1.11h-3.75L10.179 0H4.82L3.75 1.111H0v2.222h15V1.111z"
        fill="#00182E"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgDelete;
